import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import styles from './testimonial.css';

const { blockquote, span, p, a } = hh(h);

const TestimonialBox = ({ image, quote, cite, link }) => (
    blockquote({ className: styles.testimonial }, [
        image ? h('img', { src: image, alt: '', className: styles.testimonialImage }) : null,
        p(link ? [quote, ' ... ', a({ href: link, target: '_blank' }, 'Read more')] : quote),
        cite ? span({ className: styles.testimonialCite }, cite) : null
    ])
);

export default TestimonialBox;


/** WEBPACK FOOTER **
 ** ./src/Universities/TestimonialBox.js
 **/